export class MassMailList{    
    ZoneID?: number;
    UserID?: number;
    DealerID?: number;
    DealerSEID?: number;
    SegmentID?: number;        
    RoleName:string;
    Subject:string;
    EmailContent:string;   
}